import React, { useState } from 'react';
import {
  Button,
  Card,
  makeStyles,
  tokens,
  Badge,
} from '@fluentui/react-components';
import {
  Filter24Regular,
  Dismiss24Regular,
  ChevronDown24Regular,
  ChevronUp24Regular,
} from '@fluentui/react-icons';

const useStyles = makeStyles({
  container: {
    marginBottom: '16px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '12px',
    flexWrap: 'wrap',
    gap: '8px',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  card: {
    padding: '16px',
  },
  filtersGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '16px',
    marginBottom: '16px',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
    paddingTop: '8px',
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
  },
});

interface AdvancedFiltersProps {
  children: React.ReactNode;
  onApply: () => void;
  onClear: () => void;
  activeFiltersCount?: number;
  defaultExpanded?: boolean;
}

export const AdvancedFilters: React.FC<AdvancedFiltersProps> = ({
  children,
  onApply,
  onClear,
  activeFiltersCount = 0,
  defaultExpanded = false,
}) => {
  const styles = useStyles();
  const [expanded, setExpanded] = useState(defaultExpanded);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <Button
            icon={expanded ? <ChevronUp24Regular /> : <ChevronDown24Regular />}
            appearance="subtle"
            onClick={handleToggle}
          >
            {expanded ? 'Ocultar Filtros' : 'Mostrar Filtros'}
          </Button>
          {activeFiltersCount > 0 && (
            <Badge appearance="filled" color="informative">
              {activeFiltersCount} {activeFiltersCount === 1 ? 'filtro ativo' : 'filtros ativos'}
            </Badge>
          )}
        </div>
        {activeFiltersCount > 0 && !expanded && (
          <div className={styles.headerRight}>
            <Button
              icon={<Dismiss24Regular />}
              appearance="subtle"
              onClick={onClear}
            >
              Limpar Filtros
            </Button>
          </div>
        )}
      </div>

      {expanded && (
        <Card className={styles.card}>
          <div className={styles.filtersGrid}>{children}</div>

          <div className={styles.actions}>
            <Button appearance="secondary" onClick={onClear}>
              Limpar
            </Button>
            <Button appearance="primary" icon={<Filter24Regular />} onClick={onApply}>
              Aplicar Filtros
            </Button>
          </div>
        </Card>
      )}
    </div>
  );
};

export default AdvancedFilters;
